<template>
  <div class="w100 pl20 bg-w pr20 pt20 pb20" v-loading="loading">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane name="bpmnPageProcess">
        <span slot="label"> 全部 </span>
      </el-tab-pane>
      <el-tab-pane name="bpmnPageOwenProcess">
        <span slot="label">
          我发起的
          <el-badge :value="tabJson.owntasks || ''" class="item"></el-badge>
        </span>
      </el-tab-pane>
      <el-tab-pane name="bpmnPageTodoProcess">
        <span slot="label">
          我的待办
          <el-badge :value="tabJson.mytasks || ''" class="item"></el-badge>
        </span>
      </el-tab-pane>
      <el-tab-pane name="bpmnPageHasdoneProcess">
        <span slot="label">
          我的已办
          <el-badge :value="tabJson.mydonetasks || ''" class="item"></el-badge>
        </span>
      </el-tab-pane>
      <el-tab-pane name="getMyReportList">
        <span slot="label">
          填报任务
          <el-badge :value="tabJson.reporttasks || ''" class="item"></el-badge>
        </span>
      </el-tab-pane>
      <el-tab-pane name="getPageCs">
        <span slot="label">
          抄送 <el-badge :value="numCs" class="item"></el-badge>
        </span>
      </el-tab-pane>
      <el-tab-pane name="myDraftsProcess">
        <span slot="label">
          草稿 <el-badge :value="tabJson.mydrafts || ''" class="item"></el-badge>
        </span>
      </el-tab-pane>
    </el-tabs>
    <div class="table-con">
      <!-- <div class="M_search" style="justify-content:flex-end" v-if="activeName=='getMyReportList'">
                <div class="rightBtn">
                    <el-button
                            style="float: right"
                            type="primary"
                            icon="el-icon-document"
                            @click="toRoute"
                    >发起填报任务
                    </el-button>
                </div>
            </div> -->
      <ul v-if="!allExport">
        <div
          v-if="activeName == 'bpmnPageProcess'"
          style="
            display: flex;
            align-items: center;
            justify-content: flex-start;
          "
        >
          <span>活动方案名称：</span>
          <el-input
            style="width: 200px; margin-right: 10px"
            v-model="seach"
            placeholder="请输入方案关键字"
          ></el-input>
          <el-button type="primary" @click="getListFn">查询</el-button>
        </div>
        <div v-if="activeName == 'getPageCs'">
          <el-select
            v-model="cpType"
            placeholder="请选择阅读状态"
            @change="cpChange"
          >
            <el-option label="全部" value=""></el-option>
            <el-option label="待阅" value="0"></el-option>
            <el-option label="已阅" value="1"></el-option>
          </el-select>
        </div>
        <!-- <li
                    v-if="activeName == 'getMyReportList'&&!loading"
                    v-for="item in list"
                    class="cl-f"
                    @click="liClick(item)"
                    :class="{'bpmnPageProcess':(activeName=='bpmnPageProcess'||activeName=='getMyReportList')}">

                    <el-row class="rows">
                        <el-col class="cols" :span="1" align="center"> <img class="icon" :src="`${baseUrl}images/file_icon.png`"></el-col>
                        <el-col class="cols" :span="14">
                            <span class="name bold"  v-text="item.serveName||item.taskName||item.reportName" ></span>
                        </el-col>
                        <el-col class="cols" :span="9" align="right">
                             <span style="display: block;text-align: left"
                                   v-if="activeName=='bpmnPageOwenProcess'">
                        <span class="spanBtn"
                              :style="{'background-color': item.processStatus == '中断' ? '#C280FF' : item.processStatus == '已完成' ? '#60E46D' : '#81D3F8'}">
                            {{item.processStatus}}
                        </span>
                        <i class="el-icon-time"></i>
                        {{item.createTime&&getDateDiff(item.createTime)}}</span>
                            <span class="fr"
                                  v-if="activeName=='bpmnPageTodoProcess' ||activeName=='bpmnPageHasdoneProcess' || activeName=='getPageCs'">
                        <i class="el-icon-time"></i>
                        {{item.createTime&&getDateDiff(item.createTime)}}</span>
                            <span v-if="activeName=='getMyReportList'"
                                  class="fr reportStatus" >
                        <el-button size="mini" :type="item.reportStatus!=0?'':'primary'"  :disabled="item.reportStatus!=0"
                                   @click="item.reportStatus==0&&handleReportList(item)">
                            {{ item.reportStatus!=0?'已上报':'待上报'}}</el-button>
                    </span>
                            <span v-if="activeName=='getMyReportList'"
                                  v-show="item.endDate"
                                  class="fr" style="margin-right: 10px;color: #666" v-text="item.endDate" ></span>
                            <span v-if="activeName=='getMyReportList'"
                                  class="" style="color: #666" v-text="item.deptName" ></span>
                            <span v-if="activeName=='bpmnPageProcess'" class="mytasks fr task-num">
                        待办 {{item.mytasks}}
                    </span>
                            <span v-if="activeName=='bpmnPageProcess'" class="histasks fr task-num">
                        已办 {{item.histasks}}
                    </span>
                        </el-col>
                    </el-row>
                </li> -->
        <!-- <div v-if="list.length==0&&!loading" class="no-data">无查询结果。</div> -->
        <li
          v-if="
            (activeName == 'bpmnPageProcess' && !loading) ||
            activeName == 'getMyReportList' ||
            activeName == 'getPageCs'
          "
          v-for="item in list"
          class="cl-f"
          :class="{
            bpmnPageProcess:
              activeName == 'bpmnPageProcess' ||
              activeName == 'getMyReportList',
          }"
        >
          <el-row class="rows">
            <el-col class="cols" :span="1" align="center">
              <img class="icon" :src="`${baseUrl}images/file_icon.png`"
            /></el-col>
            <el-col class="cols" :span="14">
              <span
                class="name bold"
                v-text="item.serveName || item.taskName || item.reportName"
                style="cursor: pointer;"
                @click="view(item)"
              ></span>
            </el-col>
            <el-col class="cols" :span="9" align="right">
              <span
                style="display: block; text-align: left"
                v-if="activeName == 'bpmnPageOwenProcess'"
              >
                <span
                  class="spanBtn"
                  :style="{
                    'background-color':
                      item.processStatus == '中断'
                        ? '#C280FF'
                        : item.processStatus == '已完成'
                        ? '#60E46D'
                        : '#81D3F8',
                  }"
                >
                  {{ item.processStatus }}
                </span>
                <i class="el-icon-time"></i>
                <!-- {{ item.createTime && getDateDiff(item.createTime) }}</span> -->
                {{ item.createTime}}</span>
              <span
                class="fr"
                v-if="
                  activeName == 'bpmnPageTodoProcess' ||
                  activeName == 'bpmnPageHasdoneProcess' ||
                  activeName == 'getPageCs'
                "
              >
                <i class="el-icon-time"></i>
                <!-- {{ item.createTime && getDateDiff(item.createTime) }}</span> -->
                {{ item.createTime }}</span>
              <span
                v-if="activeName == 'getMyReportList'"
                class="fr reportStatus"
              >
                <el-button
                  size="mini"
                  :type="item.reportStatus != 0 ? '' : 'primary'"
                  :disabled="item.reportStatus != 0"
                  @click="item.reportStatus == 0 && handleReportList(item)"
                >
                  {{ item.reportStatus != 0 ? "已上报" : "待上报" }}</el-button
                >
              </span>
              <span
                v-if="activeName == 'getMyReportList'"
                v-show="item.endDate"
                class="fr"
                style="margin-right: 10px; color: #666"
                v-text="item.endDate"
              ></span>
              <span
                v-if="activeName == 'getMyReportList'"
                class=""
                style="color: #666"
                v-text="item.deptName"
              ></span>
              <span
                v-if="activeName == 'bpmnPageProcess'"
                class="mytasks fr task-num"
                style="cursor: pointer;"
                @click="liClick(item,'bpmnPageTodoProcess')"
              >
                待办 {{ item.mytasks }}
              </span>
              <span
                style="cursor: pointer;"
                v-if="activeName == 'bpmnPageProcess'"
                class="histasks fr task-num"
                @click="liClick(item,'bpmnPageHasdoneProcess')"
              >
                已办 {{ item.histasks }}
              </span>
            </el-col>
          </el-row>
        </li>
        <div
          v-if="activeName == 'getMyReportList' && list.length == 0 && !loading"
          class="no-data"
        >
          无查询结果。
        </div>
        <!-- <div v-if="activeName!='getMyReportList'&&listNew.length==0&&!loading" class="no-data">无查询结果。</div> -->
      </ul>
      <div v-if="activeName == 'bpmnPageProcess' && allExport">
        <div style="display: flex; justify-content: space-between">
          <i
            @click="goBack"
            class="el-icon-arrow-left"
            style="font-size: 24px"
          ></i>
          <div>
            <el-form :model="searchForm" label-width="80px">
              <el-col :span="12" style="position: relative">
                <el-form-item label="部门班级">
                  <el-select
                    v-model="searchForm.deptName"
                    @focus="treeShow = true"
                    clearable
                    @clear="clear"
                    id="deptInput"
                  ></el-select>
                </el-form-item>
                <div
                  style="
                    position: absolute;
                    z-index: 9999;
                    height: 300px;
                    top: 37px;
                  "
                  v-if="treeShow"
                  id="deptTree"
                >
                  <treeMenu
                    ref="treeMenu"
                    initId="0"
                    :showBox="false"
                    :showArrow="false"
                    loadStyle="staticLoad"
                    style="dispaly: inline-block"
                    @nodeClick="getNodeId"
                  ></treeMenu>
                </div>
              </el-col>
              <el-col :span="12">
                <el-form-item label="姓名">
                  <el-input v-model="searchForm.name" @blur="blur"></el-input>
                </el-form-item>
              </el-col>
            </el-form>
          </div>
          <div>
            <el-button
              type="primary"
              :disabled="!instIdRow.length"
              @click="spClick('AGREE')"
              >批量通过</el-button
            >
            <el-button
              type="danger"
              :disabled="!instIdRow.length"
              @click="spClick('BACK_TO_STARTOR')"
              >批量驳回</el-button
            >
          </div>
        </div>
        <div class="advice-main">
          <el-table
            class="w100 mt20 table"
            @selection-change="handleSelectionChange"
            :show-header="true"
            header-row-class-name="table-head"
            height="620"
            :data="tableData"
          >
            <el-table-column type="selection" width="55"></el-table-column>
            <!-- <el-table-column  label="任务名称">
                            <template slot-scope="scope">
                                <span v-text="scope.row.taskName" ></span>
                                <span>[{{scope.row.xqmc}}]</span>
                                <span v-if="lxShow" :style="{color: scope.row.qfje == 0 ? '#4cdd1c' : '#ff210b'}">{{scope.row.qfje == 0 ? '(学费已交清/' : '(学费未交清/'}}</span>
                                <span v-if="lxShow" :style="{color: scope.row.sbwh == 0 ? '#4cdd1c' : '#ff210b'}">{{scope.row.sbwh == 0 ? '图书已归还)' : '图书未归还)'}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="type" align="center" label="任务状态" width="120">
                            <template slot-scope="scope">
                                <div style="width: 120px;background-color: #81D3F8;color: #ffffff">进行中</div>
                            </template>
                        </el-table-column>
                        <el-table-column label="创建时间" prop="createTime" align="center" width="200"></el-table-column> -->
            <el-table-column
              label="申请人"
              prop="createUser"
              align="center"
              width="120"
            ></el-table-column>
            <el-table-column
              label="学院/专业/班级"
              prop="applyDept"
              align="center"
            ></el-table-column>
            <el-table-column
              label="创建时间"
              prop="createTime"
              align="center"
              width="150"
            ></el-table-column>
            <el-table-column
              prop="type"
              align="center"
              label="流程表单"
              width="120"
            >
              <template slot-scope="scope">
                <div
                  style="
                    width: 120px;
                    background-color: #81d3f8;
                    color: #ffffff;
                    cursor: pointer;
                  "
                  @click="view(scope.row)"
                >
                  查看
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="mt20 flex-box">
          <div class="flex-1"></div>
          <el-pagination
            background
            @size-change="changeProSize"
            @current-change="changeProPage"
            :current-page="paramProSearch.current"
            :page-sizes="pageProSizes"
            :page-size="paramProSearch.size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="paramProSearch.total"
          ></el-pagination>
        </div>
      </div>
    </div>
    <!-- 我发起的 -->
    <div v-show="activeName == 'bpmnPageOwenProcess'">
      <!-- 查询条件 -->
      <div>
        <el-form :model="searchForm1" label-width="80px">
          <el-col :span="12" style="width: 300px">
            <el-form-item label="流程名称">
              <el-input
                v-model="searchForm1.keywords"
                @blur="blurPo"
                @clear="clearPo"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="状态">
              <el-select
                v-model="searchForm1.processState"
                placeholder="请选择"
                style="width: 200px"
                clearable
                @change="changePo"
              >
                <el-option
                  v-for="item in stateList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-form>
      </div>
      <el-table
        class="w100 mt20 table"
        @selection-change="handleSelectionChange"
        :show-header="true"
        header-row-class-name="table-head"
        height="620"
        :data="listNew"
      >
        <el-table-column
          label="流程名称"
          prop="processName"
          align="left"
        ></el-table-column>
        <el-table-column
          label="状态"
          prop="taskStatus"
          align="center"
          width="150"
        >
          <template slot-scope="scope">
            <el-button
              type="danger"
              circle
              style="padding: 3px; vertical-align: middle; margin-right: 5px"
              v-show="scope.row.taskStatus == '作废'"
            ></el-button>
            <el-button
              type="primary"
              circle
              style="padding: 3px; vertical-align: middle; margin-right: 5px"
              v-show="scope.row.taskStatus == '运行中'"
            ></el-button>
            <el-button
              type="success"
              circle
              style="padding: 3px; vertical-align: middle; margin-right: 5px"
              v-show="scope.row.taskStatus == '成功结束'"
            ></el-button>
            <span>{{ scope.row.taskStatus }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="创建时间"
          prop="createTime"
          align="center"
          width="150"
        ></el-table-column>
        <el-table-column
          prop="type"
          align="center"
          label="流程表单"
          width="120"
        >
          <template slot-scope="scope">
            <div
              style="
                width: 120px;
                background-color: #81d3f8;
                color: #ffffff;
                cursor: pointer;
              "
              @click="view(scope.row)"
            >
              查看
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 我的待办 -->
    <div v-show="activeName == 'bpmnPageTodoProcess'||activeName == 'myDraftsProcess'">
      <!-- 查询条件 -->
      <div>
        <el-form :model="searchForm2" label-width="80px">
          <el-col :span="8" style="width: 300px">
            <el-form-item label="流程名称">
              <el-input
                v-model="searchForm2.keywords"
                @blur="blurPo1"
                @clear="clearPo1"
                @keyup.enter.native="blurPo1"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8" style="position: relative">
            <el-form-item label="部门班级">
              <el-select
                v-model="searchForm2.deptName"
                @focus="treeShow1 = true"
                clearable
                @clear="clear1"
                id="deptInput1"
              ></el-select>
            </el-form-item>
            <div
              style="
                position: absolute;
                z-index: 9999;
                height: 300px;
                top: 37px;
              "
              v-if="treeShow1"
              id="deptTree1"
            >
              <treeMenu
                ref="treeMenu"
                initId="0"
                :showBox="false"
                :showArrow="false"
                loadStyle="staticLoad"
                style="dispaly: inline-block"
                @nodeClick="getNodeId1"
              ></treeMenu>
            </div>
          </el-col>
          <el-col :span="8">
            <el-form-item label="姓名">
              <div style="display: flex">
                <el-input
                  v-model="searchForm2.name"
                  @keyup.enter.native="blur1"
                ></el-input>
                <el-button
                  type="primary"
                  style="margin-left: 5px"
                  @click="getSpData1"
                  >查询</el-button
                >
              </div>
            </el-form-item>
          </el-col>
        </el-form>
      </div>
      <el-table
        class="w100 mt20 table"
        @selection-change="handleSelectionChange"
        :show-header="true"
        header-row-class-name="table-head"
        height="620"
        :data="listNew"
      >
        <el-table-column
          label="申请人"
          prop="createUser"
          align="center"
          width="120"
        ></el-table-column>
        <el-table-column
          label="学院/专业/班级"
          prop="applyDept"
          align="center"
        ></el-table-column>
        <el-table-column
          label="流程名称"
          prop="processName"
          align="left"
        ></el-table-column>
        <el-table-column
          label="创建时间"
          prop="createTime"
          align="center"
          width="150"
        ></el-table-column>
        <el-table-column
          prop="type"
          align="center"
          label="流程表单"
          width="120"
        >
          <template slot-scope="scope">
            <div
              style="
                width: 120px;
                background-color: #81d3f8;
                color: #ffffff;
                cursor: pointer;
              "
              @click="view(scope.row)"
            >
              查看
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 我的已办 -->
    <div v-show="activeName == 'bpmnPageHasdoneProcess'">
      <!-- 查询条件 -->
      <div>
        <el-form :model="searchForm2" label-width="80px">
          <el-col :span="8" style="position: relative">
            <el-form-item label="部门班级">
              <el-select
                v-model="searchForm2.deptName"
                @focus="treeShow2 = true"
                clearable
                @clear="clear2"
                id="deptInput2"
              ></el-select>
            </el-form-item>
            <div
              style="
                position: absolute;
                z-index: 9999;
                height: 300px;
                top: 37px;
              "
              v-if="treeShow2"
              id="deptTree2"
            >
              <treeMenu
                ref="treeMenu"
                initId="0"
                :showBox="false"
                :showArrow="false"
                loadStyle="staticLoad"
                style="dispaly: inline-block"
                @nodeClick="getNodeId2"
              ></treeMenu>
            </div>
          </el-col>
          <el-col :span="8">
            <el-form-item label="姓名">
              <el-input v-model="searchForm2.name" @blur="blur2"></el-input>
            </el-form-item>
          </el-col>
        </el-form>
      </div>
      <el-table
        class="w100 mt20 table"
        @selection-change="handleSelectionChange"
        :show-header="true"
        header-row-class-name="table-head"
        height="620"
        :data="listNew"
      >
        <el-table-column
          label="申请人"
          prop="createUser"
          align="center"
          width="120"
        ></el-table-column>
        <el-table-column
          label="学院/专业/班级"
          prop="applyDept"
          align="center"
        ></el-table-column>
        <el-table-column
          label="流程名称"
          prop="processName"
          align="left"
        ></el-table-column>
        <el-table-column
          label="创建时间"
          prop="createTime"
          align="center"
          width="150"
        ></el-table-column>
        <el-table-column
          prop="type"
          align="center"
          label="流程表单"
          width="120"
        >
          <template slot-scope="scope">
            <div
              style="
                width: 120px;
                background-color: #81d3f8;
                color: #ffffff;
                cursor: pointer;
              "
              @click="view(scope.row)"
            >
              查看
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="mt20 flex-box" v-if="!allExport">
      <div class="flex-1"></div>
      <el-pagination
        background
        @size-change="changeSize"
        @current-change="changePage"
        :current-page="paramSearch.current"
        :page-sizes="pageSizes"
        :page-size="paramSearch.size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>

    <IframeView ref="IframeView" @sub-true="subTrue"></IframeView>
    <batchModel :leaData="leaData" @close="getPage"></batchModel>
  </div>
</template>

<script>
import * as serve from "@/api/bpmnApi/bpmn";
import { getDateDiff } from "@/util/utils";
import IframeView from "@/components/public/IframeView.vue";
import batchModel from "@/views/mine/myAffair/batchModel.vue";
import treeMenu from "@/components/treeMenu/index.vue";
export default {
  name: "myAffair",
  components: {
    IframeView,
    batchModel,
    treeMenu,
  },
  props: [],
  data() {
    return {
      baseUrl: process.env.BASE_URL,
      loading: false,
      list: [],
      reportList: [],
      pageSizes: [10, 20, 30, 50, 100],
      paramSearch: {
        current: 1,
        size: 10,
      },
      total: 0,
      activeName: "bpmnPageProcess",
      tabJson: {},
      seach: "",
      cpType: "0",
      allExport: false,
      tableData: [],
      tableNew: [],
      loadingSp: false,
      rowObj: {},
      instIdRow: [],
      leaData: {
        type: "",
        instIds: "",
        show: false,
      },
      numCs: "",
      paramProSearch: {
        current: 1,
        size: 10,
        total: 0,
      },
      pageProSizes: [10, 20, 30, 50, 100],
      //学费交清，图书归还仅在离校申请列表显示
      lxShow: false,
      //查询表单
      searchForm: {
        deptName: "",
        name: "",
      },
      treeShow: false,
      listNew: [],
      //我的发起查询
      searchForm1: {
        keywords: "",
        processState: "",
      },
      //状态列表
      stateList: [
        { value: "active", label: "运行中" },
        { value: "complete", label: "完成" },
        { value: "terminate", label: "终止" },
      ],
      //我的待办查询
      searchForm2: {
        keywords: "",
        deptName: "",
        name: "",
      },
      treeShow1: false,
      treeShow2: false,
    };
  },
  computed: {},
  created() {
    //关闭ifram组件后刷新
    window.addEventListener("message", () => {
      this.getListFnNew();
      this.getSpData();
    });
    //部门班级筛选
    document.addEventListener("click", e => {
      let deptTree = document.getElementById("deptTree");
      let deptInput = document.getElementById("deptInput");
      if (deptTree != null) {
        if (!deptTree.contains(e.target)) {
          this.treeShow = false;
        }
      }
      if (deptInput != null) {
        if (deptInput.contains(e.target)) {
          this.treeShow = true;
        }
      }

      let deptTree1 = document.getElementById("deptTree1");
      let deptInput1 = document.getElementById("deptInput1");
      if (deptTree1 != null) {
        if (!deptTree1.contains(e.target)) {
          this.treeShow1 = false;
        }
      }
      if (deptInput1 != null) {
        if (deptInput1.contains(e.target)) {
          this.treeShow1 = true;
        }
      }

      let deptTree2 = document.getElementById("deptTree2");
      let deptInput2 = document.getElementById("deptInput2");
      if (deptTree2 != null) {
        if (!deptTree2.contains(e.target)) {
          this.treeShow2 = false;
        }
      }
      if (deptInput2 != null) {
        if (deptInput2.contains(e.target)) {
          this.treeShow2 = true;
        }
      }
    });
  },
  mounted() {
    this.getBpmnCountPersonProcess();
    this.getNumCsData();
    this.getListFn();
  },
  methods: {
    subTrue() {
      this.getBpmnCountPersonProcess();
      this.getNumCsData();
      this.getListFn();
    },
    cpChange() {
      this.getNumCsData();
      this.getListFn();
    },
    getNumCsData() {
      serve
        .getNumCs()
        .then(res => {
          if (res.data.code == "0") {
            this.numCs = res.data.data;
          } else {
            this.$message.warning(res.data.msg);
          }
        })
        .catch(err => {
          this.$message.error("服务器异常!");
        });
    },
    handleSelectionChange(val) {
      this.instIdRow = val;
    },
    spClick(type) {
      if (
        this.instIdRow.map(a => !(a.qfje == 0 && a.sbwh == 0)).filter(r => r)
          .length > 0 &&
        this.lxShow
      ) {
        this.$alert("你选择的数据存在未缴费或图书未归还，请重新选择!", "提示", {
          confirmButtonText: "确定",
          type: "warning",
        });
      } else {
        this.leaData.type = type;
        this.leaData.taskIds = this.instIdRow
          .map(item => {
            return item.taskId;
          })
          .join(",");
        this.leaData.show = true;
      }
    },
    //跳转到填报任务页面
    toRoute() {
      this.$router.push(`/management/reportManage`);
    },
    handleReportList(item) {
      let processDefId = item.processDefId;
      let detailId = item.detailId;
      let isMobile = false;
      serve
        .bpmnStartProcessNew({ processDefId, isMobile, detailId })
        .then(({ data }) => {
          if (data.code == 0) {
            this.$refs.IframeView.showView(data.data.url, data.data.taskInstId);
            // let params= {
            //     batchNo: item.batchNo,
            //     reportId: item.reportId
            // }
            // serve.bpmnSubmitMyReport(params).then(({data})=> {
            //     if (data.code == 0) {
            this.getListFn();
            //     } else {
            //         this.$message.warning(data.msg||'流程系统业务忙，请刷新或者重新操作');

            //     }
            // })
          } else {
            this.$message.warning("流程系统业务忙，请刷新或者重新操作");
          }
        })
        .catch(err => {
          return;
          this.$message.error("服务异常");
        });
    },
    getDateDiff(value) {
      return getDateDiff(value);
    },
    liClick(item,type) {
      //离校则显示学费缴费、图书归还提示
      if (item.processDefCode == "WMLX") {
        this.lxShow = true;
      } else {
        this.lxShow = false;
      }
      if (this.activeName == "getMyReportList") {
        return;
      }
      if (this.activeName == "bpmnPageProcess") {
        this.paramProSearch.size = 10;
        this.paramProSearch.current = 1;
        this.allExport = true;
        this.rowObj = item;
        this.getSpData(type);
        return;
      }
      this.$refs.IframeView.showView(item.taskUrl, item.taskId);
    },
    getPage() {
      this.paramProSearch.size = 10;
      this.paramProSearch.current = 1;
      this.getBpmnCountPersonProcess();
      this.getSpData();
    },
    getSpData(type) {
      this.loadingSp = true;
      let params = {
        ...this.paramProSearch,
        processDefCode: this.rowObj.processDefCode || "",
      };
      serve[type](params)
        // .bpmnPageTodoProcess(params)
        .then(({ data }) => {
          this.loadingSp = false;
          if (data.code == 0) {
            let datas = data.data.records;
            this.tableNew = datas.filter(item => item.processVerId == "WMLX");
            if (this.tableNew.length > 0) {
              let str = this.tableNew
                .map(a => {
                  return a.instId;
                })
                .join(",");
              this.getTableDataStatus(str, data.data.total);
            } else {
              this.tableData = datas || [];
              this.paramProSearch.total = data.data.total;
            }
          }
        })
        .catch(err => {
          this.loadingSp = false;
        });
    },
    getSpData1() {
      this.loadingSp = true;
      this.listNew = [];
      this.total = 0;
      this.paramProSearch.applyUser = this.searchForm2.name;
      let params = {
        keywords: this.seach,
        ...this.paramProSearch,
        // processDefCode: this.rowObj.processDefCode || ''
      };
      serve[this.activeName](params)
        .then(({ data }) => {
          this.loadingSp = false;
          if (data.code == 0) {
            let datas = data.data.records;
            this.listNew = datas || [];
            this.total = data.data.total;
          }
        })
        .catch(err => {
          this.loadingSp = false;
        });
    },
    getSpData2() {
      this.loadingSp = true;
      this.listNew = [];
      let params = {
        keywords: this.seach,
        ...this.paramProSearch,
        processDefCode: this.rowObj.processDefCode || "",
      };
      serve
        .bpmnPageHasdoneProcess(params)
        .then(({ data }) => {
          this.loadingSp = false;
          if (data.code == 0) {
            let datas = data.data.records;
            this.listNew = datas || [];
            this.total = data.data.total;
          }
        })
        .catch(err => {
          this.loadingSp = false;
        });
    },
    getTableDataStatus(str, total) {
      let params = {
        instIdStr: str,
      };
      // this.$http.post( "/jsaas/sys/db/sysSqlCustomQuery/queryForJson_qfwhts.do", params,{ baseURL: "/jsaas" } )
      //     .then( ({ data }) => {
      //         console.log(data,'data234223');
      //     })
      //     .catch(() => {
      //
      //     })
      serve.getMsgStatus(params).then(res => {
        if (res.data.data.length > 0) {
          let data = res.data.data;
          this.tableData = this.tableNew.map((a, i) => {
            return {
              ...a,
              qfje: data[i].qfje,
              sbwh: data[i].sbwh,
              xqmc: data[i].xqmc,
            };
          });
          this.paramProSearch.total = total;
        }
      });
    },
    goBack() {
      this.allExport = false;
      this.getListFn();
    },
    handleClick() {
      this.listNew=[];
      this.total=0;
      this.seach = "";
      this.searchForm1.processState = "";
      this.searchForm1.keywords = "";
      this.searchForm2.keywords = "";
      this.searchForm2.deptName = "";
      this.searchForm.deptName = "";
      this.searchForm.name = "";
      this.searchForm2.name = "";
      this.paramSearch.size = 10;
      this.paramSearch.current = 1;
      if (this.activeName != "bpmnPageProcess") {
        this.allExport = false;
      }
      this.getNumCsData();
      if (
        this.activeName == "bpmnPageProcess" ||
        this.activeName == "getMyReportList" ||
        this.activeName == "getPageCs"
      ) {
        this.getListFn();
      } else {
        this.getListFnNew();
      }
      this.getBpmnCountPersonProcess();
    },
    getBpmnCountPersonProcess() {
      serve
        .bpmnCountPersonProcess()
        .then(({ data }) => {
          if (data.code == 0) {
            this.tabJson = data.data || {};
          }
        })
        .catch(err => {});
    },
    getListFn() {
      this.loading = true;
      let params = {
        ...this.paramSearch,
        keywords: this.seach,
        cpType: this.cpType,
        requestType: "pc",
      };
      serve[this.activeName](params)
        .then(({ data }) => {
          this.loading = false;
          if (data.code == 0) {
            this.list = data.data.records || [];
            this.total = data.data.total;
          }else{
            this.list = [];
            this.total = 0;
          }
        })
        .catch(err => {
          this.loading = false;
        });
    },
    getListFnNew() {
      this.loading = true;
      let params = {
        ...this.paramSearch,
        keywords: this.seach,
        cpType: this.cpType,
        requestType: "pc",
      };
      serve[this.activeName](params)
        .then(({ data }) => {
          this.loading = false;
          if (data.code == 0) {
            this.listNew = data.data.records || [];
            this.total = data.data.total;
          }
        })
        .catch(err => {
          this.loading = false;
        });
    },
    // 条数
    changeSize(value) {
      this.paramSearch.size = value;
      this.paramSearch.current = 1;
      if (this.activeName == "bpmnPageProcess") {
        this.getListFn();
      } else {
        this.getListFnNew();
      }
    },
    // 翻页
    changePage(value) {
      this.paramSearch.current = value;
      if (
        this.activeName == "bpmnPageProcess" ||
        this.activeName == "getMyReportList"
      ) {
        this.getListFn();
      } else {
        this.getListFnNew();
      }
    },
    // 条数
    changeProSize(value) {
      this.paramProSearch.size = value;
      this.paramProSearch.current = 1;
      this.getSpData();
    },
    // 翻页
    changeProPage(value) {
      this.paramProSearch.current = value;
      this.getSpData();
    },
    //部门班级点击
    getNodeId(val) {
      this.paramProSearch.dept = val.id;
      this.searchForm.deptName = val.name;
      this.getSpData();
      this.treeShow = false;
    },
    //部门班级清除
    clear() {
      this.paramProSearch.dept = "";
      this.searchForm.deptName = "";
      this.getSpData();
      this.treeShow = false;
    },
    //部门班级清除1
    clear1() {
      this.paramProSearch.dept = "";
      this.searchForm2.deptName = "";
      this.getSpData1();
      this.treeShow1 = false;
    },
    //部门班级清除2
    clear2() {
      this.paramProSearch.dept = "";
      this.searchForm2.deptName = "";
      this.getSpData1();
      this.treeShow2 = false;
    },
    //部门班级点击1
    getNodeId1(val) {
      this.paramProSearch.dept = val.id;
      this.searchForm2.deptName = val.name;
      this.getSpData1();
      this.treeShow1 = false;
      this.treeShow2 = false;
    },
    //部门班级点击2 我的已办
    getNodeId2(val) {
      this.paramProSearch.dept = val.id;
      this.searchForm2.deptName = val.name;
      this.getSpData2();
      this.treeShow1 = false;
      this.treeShow2 = false;
    },
    //姓名1
    blur1() {
      this.paramProSearch.applyUser = this.searchForm2.name;
      this.getSpData1();
    },
    //姓名2
    blur2() {
      this.paramProSearch.applyUser = this.searchForm2.name;
      this.getSpData2();
    },
    //姓名
    blur() {
      this.paramProSearch.applyUser = this.searchForm.name;
      this.getSpData();
    },
    view(val) {
      console.log(val);
      this.$refs.IframeView.showView(val.taskUrl, val.taskId);
    },
    //我的发起查询
    blurPo() {
      this.seach = this.searchForm1.keywords;
      this.getListFnNew();
    },
    clearPo() {
      this.seach = "";
      this.getListFnNew();
    },
    //我的待办查询
    blurPo1() {
      this.seach = this.searchForm2.keywords;
      this.getSpData1();
    },
    clearPo1() {
      this.seach = "";
      this.getSpData1();
    },
    //状态查询
    changePo() {
      this.paramSearch.processState = this.searchForm1.processState;
      this.getListFnNew();
    },
  },
  watch: {},
  filters: {},
};
</script>

<style scoped lang="less">
/deep/.el-tabs__item.is-active {
  color: #064576;
}
/deep/.el-tabs__active-bar {
  background-color: #064576;
}
/deep/#tab-bpmnPageProcess {
  width: 80px;
  text-align: center;
}
.table-con {
  /*height:calc(100vh - 240px);*/
  overflow: auto;
  ul {
    li {
      .rows {
        .cols {
          // cursor: pointer;
          height: 60px;
          background: #f7f7f7;
          padding: 0 8px;
          line-height: 60px;
          margin-bottom: 9px;
          padding-right: 20px;
          &.bpmnPageProcess {
            // cursor: initial;
          }
          // &:hover {
          //   box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05),
          //     0 0 3px rgba(0, 0, 0, 0.04);
          // }
          > .icon {
            width: 20px;
            padding-top: 15px;
          }
          > span {
            display: inline-block;
            vertical-align: top;
            padding: 0 12px;
            &.name {
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
            &.reportStatus {
              width: 80px;
              height: 30px;
            }
            .el-icon-time {
              margin-left: 20px;
              font-weight: bold;
              color: #666;
            }
            .spanBtn {
              padding: 8px 40px;
              color: #ffffff;
            }
          }
          > .task-num {
            margin-top: 15px;
            min-width: 66px;
            height: 30px;
            line-height: 30px;
            margin-left: 20px;
            font-family: Microsoft YaHei;
            font-weight: 400;
          }
          > .mytasks {
            background: #e8f7fa;
            color: #39c0db;
          }
          > .histasks {
            background: #ffefef;
            color: #f36f6f;
          }
        }
      }
    }
  }
}
</style>
